import { UserRole } from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useMemo } from "react"

import { useCoachingSubscriptionQuery } from "../networking/coachingGroups/queries"
import { CoachingGroup } from "../types"
import {
  isInactiveClient,
  isNewClient,
  isReactivatedClient,
} from "../util/coachingGroups"

export const useCoachingGroup = (coachingGroup: CoachingGroup | undefined) => {
  const client = useMemo(
    () =>
      coachingGroup?.profiles.find(
        (profile) => profile.role === UserRole.CLIENT
      ),
    [coachingGroup]
  )
  const { data: clientSubscriptionInfo } = useCoachingSubscriptionQuery(
    client?.user.id
  )

  const { isPaused, subscriptionResumeDate } = useMemo(() => {
    const subResumeDate = clientSubscriptionInfo?.pause_collection_end_datetime
    return {
      isPaused: !!subResumeDate,
      subscriptionResumeDate: subResumeDate
        ? dayjs(subResumeDate).format("MMM D")
        : null,
    }
  }, [clientSubscriptionInfo])

  const isInactive = useMemo(() => {
    if (!coachingGroup) return false
    return isInactiveClient(coachingGroup)
  }, [coachingGroup])

  const isNew = useMemo(() => {
    if (!coachingGroup) return false
    return isNewClient(coachingGroup?.date_created)
  }, [coachingGroup])

  const isReactivated = useMemo(() => {
    if (!coachingGroup) return false
    return isReactivatedClient(coachingGroup)
  }, [coachingGroup])

  return {
    client,
    isInactive,
    isNew,
    isReactivated,
    isPaused,
    subscriptionResumeDate,
  }
}

export default useCoachingGroup
